export default {
  copyAddress: {
    id: 'bo_sellers-orders-drawers-copy-address',
    defaultMessage: 'Copy address',
  },
  fullName: {
    id: 'global_full_name',
    defaultMessage: '{firstName} {lastName}',
  },
  company: {
    id: 'bo_sellers-orders-drawers-order_recap-company-name',
    defaultMessage: 'Company {companyName}',
  },
  fiscalIdentificationNumber: {
    id: 'bo_sellers-orders-drawers-order_recap-order_details-fiscal-identification-number',
    defaultMessage: 'NIF',
  },
} as const
